import { SegmentedToggle } from "@Light/components/page/SegmentedToggle";

export type RateTermToggleProps = {
  terms: number[];
  selected: number;
  onChange: (term: number) => void;
  disabled?: boolean;
};

export function RateTermToggle({
  terms,
  selected,
  onChange,
  disabled,
}: RateTermToggleProps) {
  return (
    <SegmentedToggle
      testId="rate-term-toggle"
      selected={selected}
      onChange={onChange}
      disabled={disabled}
      options={terms.map((term) => ({
        value: term,
        label: `${term} months`,
        testId: `rate-term-${term}`,
      }))}
    />
  );
}
